import { useEffect, useState } from 'react';
import ExternalSpinner from 'ui-kit/Spinner';

interface Props {
  size: number;
  color: string;
  backgroundColor: string;
  duration: number;
}

export const ProgressSpinner = ({
  size = 24,
  color = 'white',
  backgroundColor = 'rgba(255, 255, 255, 0.3)',
  duration = 60
}: Props) => {
  const [isTimeElapsed, setIsTimeElapsed] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsTimeElapsed(true);
    }, duration * 1000);

    return () => clearTimeout(timer);
  }, [duration]);

  if (isTimeElapsed) {
    return <ExternalSpinner size={size} color={color} backgroundColor={backgroundColor} />;
  }

  const radius = 45;
  const circumference = 2 * Math.PI * radius;

  return (
    <div role="status" style={{ width: size, height: size }}>
      <svg
        style={{ width: size, height: size }}
        viewBox="0 0 100 100"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="50" cy="50" r={radius} fill="none" stroke={backgroundColor} strokeWidth="10" />

        <circle
          cx="50"
          cy="50"
          r={radius}
          fill="none"
          stroke={color}
          strokeWidth="10"
          strokeDasharray={circumference}
          strokeDashoffset={circumference}
          style={{
            transformOrigin: 'center',
            transform: 'rotate(-90deg)',
            WebkitAnimation: `progress ${duration}s linear infinite`,
            MozAnimation: `progress ${duration}s linear infinite`,
            animation: `progress ${duration}s linear infinite`
          }}
        />
      </svg>
      <style>
        {`
          @-webkit-keyframes progress {
            0% {
              stroke-dashoffset: ${circumference};
            }
            100% {
              stroke-dashoffset: 0;
            }
          }
          @-moz-keyframes progress {
            0% {
              stroke-dashoffset: ${circumference};
            }
            100% {
              stroke-dashoffset: 0;
            }
          }
          @-ms-keyframes progress {
            0% {
              stroke-dashoffset: ${circumference};
            }
            100% {
              stroke-dashoffset: 0;
            }
          }
          @-o-keyframes progress {
            0% {
              stroke-dashoffset: ${circumference};
            }
            100% {
              stroke-dashoffset: 0;
            }
          }
          @keyframes progress {
            0% {
              stroke-dashoffset: ${circumference};
            }
            100% {
              stroke-dashoffset: 0;
            }
          }
        `}
      </style>
      <span className="sr-only">Loading...</span>
    </div>
  );
};
